module.exports = __webpack_public_path__ + "img/product_72.df31d8b.webp";